// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  orgId: __t.string().name("org_id"),
  projectId: __t.string().name("project_id"),
  assetId: __t.string().name("asset_id"),
  clipId: __t.string().name("clip_id"),
  name: __t.string(),
  box: __t.string(),
  atUs: __t.f64().name("at_us"),
  fromUs: __t.f64().name("from_us"),
  toUs: __t.f64().name("to_us"),
  jobId: __t.string().name("job_id"),
  status: __t.string(),
  error: __t.string(),
  data: __t.string(),
  createdByName: __t.string().name("created_by_name"),
  createdAt: __t.timestamp().name("created_at"),
  scopeId: __t.string().name("scope_id"),
});
